import { get, post } from  "@/utils/request";


/**
 * 分页获取版本信息
 */

export const userLogin = data => post('/home/logInMerchantManagePort', data);



// WEBPACK FOOTER //
// ./src/api/login.js